export default "__VITE_ASSET__DwzsPbya__"